export function getUTCTime() {
  const d1 = new Date()
  const d2 = new Date(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds())
  // 相差8小时问题 所有需要加上8 * 60 * 60 * 1000
  return Date.parse(d2) + (8 * 60 * 60 * 1000)
}
